import { motion } from 'framer-motion'
import {
  Camera,
  Compass,
  Dumbbell,
  LineChart,
  MessageCircle,
  SkipForward,
  Users,
} from 'lucide-react'

const items = [
  {
    Icon: Dumbbell,
    title: "Your trainer's workouts",
    description:
      "Plus smart suggestions for the next set's weight and reps based on what you've actually been lifting.",
  },
  {
    Icon: Camera,
    title: 'Photo-based food logging',
    description: 'Snap a picture of your meal. No calorie hunting, no barcode scanning.',
  },
  {
    Icon: MessageCircle,
    title: 'Direct messages with your trainer',
    description: 'And per-exercise notes when something needs attention.',
  },
  {
    Icon: LineChart,
    title: 'Progress photos and measurements',
    description: "Track what you actually care about, when you're ready to look.",
  },
  {
    Icon: Users,
    title: 'Optional accountability lanes',
    description: "Train alongside friends if you want extra pull. Skip if you don't.",
  },
  {
    Icon: SkipForward,
    title: 'Skips without shame',
    description:
      "Tell us why you missed today — illness, travel, life. Your trainer sees the reason and can adjust from there.",
  },
  {
    Icon: Compass,
    title: 'Stays out of your way',
    description:
      'No streak guilt, no aggressive notifications, no late-night reminders. Just here when you open it.',
  },
]

export function WhatsInside() {
  return (
    <section className="relative bg-soft-black px-6 py-20 md:py-28">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-start gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)] lg:gap-16">
        <div className="lg:sticky lg:top-24">
          <p className="inline-flex items-center gap-2 rounded-full border border-forest-green/25 bg-forest-green/[0.06] px-3 py-1 text-[11px] font-medium uppercase tracking-[0.18em] text-forest-green/90">
            Inside the app
          </p>
          <h2 className="mt-4 text-[2.1rem] font-semibold leading-[1.1] tracking-tight text-soft-white md:text-5xl">
            Everything you need. Nothing you don&apos;t.
          </h2>
          <p className="mt-4 max-w-[56ch] text-lg leading-relaxed text-muted-silver">
            Every item below is built and shipped. We&apos;re not promising features. We&apos;re describing
            the app you&apos;d use today if your trainer invited you in.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <ul role="list" className="space-y-3.5">
            {items.map((item) => {
              const { Icon } = item
              return (
                <li
                  key={item.title}
                  className="group flex gap-4 rounded-xl border border-white/[0.05] bg-charcoal-black/60 p-4 transition-all duration-200 hover:-translate-y-0.5 hover:border-forest-green/25 hover:bg-charcoal-black/80"
                >
                  <span
                    className="inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg border border-forest-green/20 bg-forest-green/10 text-forest-green"
                    aria-hidden
                  >
                    <Icon size={20} />
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-base font-semibold text-soft-white">{item.title}</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted-silver">{item.description}</p>
                  </div>
                </li>
              )
            })}
          </ul>
        </motion.div>
      </div>
    </section>
  )
}
